import React from "react"
import Stack from "@mui/material/Stack"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { COLLECTION } from "@src/constants/category"
import { Icons } from "@src/components"
import { useTranslation } from "react-i18next"
// import SiennaSvg from 'src/assets/icons/sienna.svg'

const CollectionTitle = props => {
  const { type, searchText, onSaleColor } = props
  const { t } = useTranslation()

  // Page Search
  if (searchText) {
    return (
      <Stack flexDirection="column">
        {/* <Stack justifyItems="center" gap={2}>
          <Typography variant="body2">Trang chủ</Typography>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_739_20332)">
              <path
                d="M9 6L15 12L9 18"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_739_20332">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <Typography variant="body2" fontWeight={700}>
            {searchText}
          </Typography>
        </Stack> */}
        <Stack gap={1}>
          <Typography variant="body1" fontWeight={700}>
            Kết quả tìm kiếm cho từ khoá
          </Typography>
          <Typography variant="body1" fontWeight={700} color="#FF87F4">
            {searchText}
          </Typography>
        </Stack>
      </Stack>
    )
  }

  // Page Collection
  if (type === COLLECTION.NEW_IN) {
    return (
      <Stack alignItems="center" gap={2}>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="32" height="32" rx="4" fill="#85A1FC" />
          <path
            d="M21.0244 10.268V21.5H18.2884L13.7124 14.572V21.5H10.9764V10.268H13.7124L18.2884 17.228V10.268H21.0244Z"
            fill="white"
          />
        </svg>
        <Typography
          variant="h3"
          mb="6px"
          sx={{ fontSize: "48px", fontWeight: 700 }}
        >
          New Arrival
        </Typography>
      </Stack>
    )
  }

  if (type === COLLECTION.ON_SALE) {
    return (
      <Stack alignItems="center" gap={2}>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="32" height="32" rx="4" fill={onSaleColor || "#D8042C" } />
          <path
            d="M9.53506 12.764C9.53506 12.316 9.59906 11.9267 9.72706 11.596C9.86573 11.2547 10.0524 10.972 10.2871 10.748C10.5324 10.524 10.8151 10.3533 11.1351 10.236C11.4657 10.1187 11.8231 10.06 12.2071 10.06C12.5911 10.06 12.9431 10.1187 13.2631 10.236C13.5831 10.3533 13.8604 10.524 14.0951 10.748C14.3404 10.972 14.5271 11.2547 14.6551 11.596C14.7937 11.9267 14.8631 12.316 14.8631 12.764C14.8631 13.212 14.7937 13.6067 14.6551 13.948C14.5271 14.2787 14.3404 14.556 14.0951 14.78C13.8604 15.004 13.5831 15.1747 13.2631 15.292C12.9431 15.4093 12.5911 15.468 12.2071 15.468C11.8231 15.468 11.4657 15.4093 11.1351 15.292C10.8151 15.1747 10.5324 15.004 10.2871 14.78C10.0524 14.556 9.86573 14.2787 9.72706 13.948C9.59906 13.6067 9.53506 13.212 9.53506 12.764ZM12.1911 11.66C11.9457 11.66 11.7537 11.7507 11.6151 11.932C11.4871 12.1027 11.4231 12.38 11.4231 12.764C11.4231 13.1373 11.4871 13.4147 11.6151 13.596C11.7537 13.7667 11.9457 13.852 12.1911 13.852C12.4364 13.852 12.6284 13.7667 12.7671 13.596C12.9057 13.4147 12.9751 13.1373 12.9751 12.764C12.9751 12.38 12.9057 12.1027 12.7671 11.932C12.6284 11.7507 12.4364 11.66 12.1911 11.66ZM17.7591 10.236H20.3991L14.2391 21.5H11.5991L17.7591 10.236ZM17.1511 18.972C17.1511 18.524 17.2151 18.1347 17.3431 17.804C17.4817 17.4627 17.6684 17.18 17.9031 16.956C18.1484 16.7213 18.4311 16.5507 18.7511 16.444C19.0711 16.3267 19.4231 16.268 19.8071 16.268C20.1911 16.268 20.5431 16.3267 20.8631 16.444C21.1831 16.5507 21.4604 16.7213 21.6951 16.956C21.9404 17.18 22.1271 17.4627 22.2551 17.804C22.3937 18.1347 22.4631 18.524 22.4631 18.972C22.4631 19.42 22.3937 19.8147 22.2551 20.156C22.1271 20.4867 21.9404 20.764 21.6951 20.988C21.4604 21.212 21.1831 21.3827 20.8631 21.5C20.5431 21.6173 20.1911 21.676 19.8071 21.676C19.4231 21.676 19.0711 21.6173 18.7511 21.5C18.4311 21.3827 18.1484 21.212 17.9031 20.988C17.6684 20.764 17.4817 20.4867 17.3431 20.156C17.2151 19.8147 17.1511 19.42 17.1511 18.972ZM19.7911 17.868C19.5457 17.868 19.3537 17.9587 19.2151 18.14C19.0871 18.3213 19.0231 18.5987 19.0231 18.972C19.0231 19.3453 19.0871 19.6227 19.2151 19.804C19.3537 19.9747 19.5457 20.06 19.7911 20.06C20.0364 20.06 20.2284 19.9747 20.3671 19.804C20.5057 19.6227 20.5751 19.3453 20.5751 18.972C20.5751 18.5987 20.5057 18.3213 20.3671 18.14C20.2284 17.9587 20.0364 17.868 19.7911 17.868Z"
            fill="white"
          />
        </svg>
        <Typography
          variant="h3"
          mb="6px"
          sx={{ fontSize: "48px", fontWeight: 700 }}
        >
          On Sale
        </Typography>
      </Stack>
    )
  }

  if (type === COLLECTION.BEST_SELLER) {
    return (
      <Stack alignItems="center" gap={2}>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="32" height="32" rx="4" fill="#8DC960" />
          <path
            d="M17.9106 18.076C17.9106 17.6707 17.7772 17.3613 17.5106 17.148C17.2546 16.924 16.8972 16.812 16.4386 16.812H14.4546V19.292H16.4706C16.9292 19.292 17.2812 19.1907 17.5266 18.988C17.7826 18.7853 17.9106 18.4813 17.9106 18.076ZM17.6386 13.644C17.6386 13.26 17.5159 12.9667 17.2706 12.764C17.0359 12.5613 16.6946 12.46 16.2466 12.46H14.4546V14.812H16.2466C16.6946 14.812 17.0359 14.716 17.2706 14.524C17.5159 14.3213 17.6386 14.028 17.6386 13.644ZM20.6786 18.444C20.6786 19.3827 20.3532 20.1293 19.7026 20.684C19.0626 21.228 18.1452 21.5 16.9506 21.5H11.7186V10.268H16.7746C17.9266 10.268 18.8226 10.5293 19.4626 11.052C20.1026 11.5747 20.4226 12.284 20.4226 13.18C20.4226 13.8627 20.2412 14.4227 19.8786 14.86C19.5159 15.2867 19.0626 15.58 18.5186 15.74C18.8492 15.804 19.1479 15.9213 19.4146 16.092C19.6812 16.2627 19.9052 16.4707 20.0866 16.716C20.2786 16.9507 20.4226 17.2173 20.5186 17.516C20.6252 17.8147 20.6786 18.124 20.6786 18.444Z"
            fill="white"
          />
        </svg>
        <Typography
          variant="h3"
          mb="6px"
          sx={{ fontSize: "48px", fontWeight: 700 }}
        >
          {t("best_seller")}
        </Typography>
      </Stack>
    )
  }

  // if (type === COLLECTION.SIENA) {
  //   return (
  //     <Stack  alignItems="center" gap={2}>
  //       <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  //         <rect width="32" height="32" rx="4" fill="#FFB8B8" />
  //         <path d="M10.9764 10.268V21.5H21.0244V10.268H10.9764Z" fill="white" />
  //       </svg>
  //       <Box sx={{
  //         'svg': {
  //           height: "48px",
  //           width: "120px"
  //         }
  //       }}>
  //         <SiennaSvg />
  //       </Box>
  //     </Stack>
  //   )
  // }
  return null
}

export default CollectionTitle
